import React, { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

type Props = PropsWithChildren<
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
>;

const WhiteOutlinedButton = ({ children, className, ...props }: Props) => {
  return (
    <button
      className={twMerge(
        "xs:h-[42px] group flex h-9 w-full items-center justify-center rounded-xl border border-white",
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default WhiteOutlinedButton;
